<template>
  <div
    class="my-5 w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition"
  >
    <BackSvg @click="$router.go(-1)" />
  </div>
  <div
    class="h-48 bg-white border border-neutral-200 rounded-lg shadow-[0_10px_50px_rgba(0,0,0,0.1)] px-4 sm:px-6"
  >
    <div class="h-full flex items-center justify-between gap-4">
      <!-- Text -->
      <div class="flex-1 min-w-0">
        <h1 class="text-lg sm:text-xl text-orange-500 font-semibold mb-2">
          {{ translations.title }}
        </h1>

        <p class="text-sm text-neutral-600 leading-relaxed">
          {{ translations.description }}
        </p>
      </div>

      <!-- Image -->
      <div class="flex-shrink-0">
        <img
          :src="require('@/assets/images/customer-service.png')"
          alt="Customer Service"
          class="w-32 sm:w-36 md:w-40 h-auto object-contain"
        />
      </div>
    </div>
  </div>
  <div class="py-6">
    <div class="py-4">
      <ul class="grid grid-cols-2 gap-4">
        <li v-for="(item, index) in itemCategories" :key="index">
          <!-- External link -->
          <a
            v-if="item.isUrl"
            :href="item.path"
            target="_blank"
            rel="noopener"
            class="block"
          >
            <div
              class="bg-white generalShadow rounded-md h-36 flex flex-col items-center justify-center space-y-2 transition hover:scale-105"
            >
              <span
                class="w-16 h-16 bg-[#E87055]/90 text-white rounded-full flex items-center justify-center"
              >
                <component :is="item.icon" height="32" width="32" />
              </span>

              <h3 class="text-orange-400 text-sm font-medium">
                {{ item.title }}
              </h3>
            </div>
          </a>

          <!-- Internal route -->
          <router-link v-else :to="item.path" class="block">
            <div
              class="bg-white generalShadow rounded-md h-36 flex flex-col items-center justify-center space-y-2 transition hover:scale-105"
            >
              <span
                class="w-16 h-16 bg-[#E87055]/90 text-white rounded-full flex items-center justify-center"
              >
                <component :is="item.icon" height="32" width="32" />
              </span>

              <h3 class="text-orange-400 text-sm font-medium text-center">
                <div>{{ item.title }}</div>
                <div class="text-xs">{{ item.subtitle }}</div>
              </h3>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { useLanguage } from "@/utils/composables/useLanguage";
import BackSvg from "@/components/svgs/BackSvg.vue";
import HeartSvg from "@/components/svgs/HeartSvg.vue";
import BuildingSvg from "@/components/svgs/BuildingSvg.vue";
import FAQSvg from "@/components/svgs/FAQSvg.vue";

import VideoSvg from "@/components/svgs/VideoSvg.vue";
import { computed } from "vue";
export default {
  components: { BackSvg, HeartSvg, BuildingSvg, FAQSvg, VideoSvg },
  setup() {
    const { selectedLanguage } = useLanguage();

    const translations = computed(
      () =>
        ({
          en: {
            title: "Welcome to the Information Center",
            description:
              "Access important information, member guides, and FAQs about IMS Wellth Care services.",
            faqTitle: "Frequently Asked Questions",
            itemCategoriesTitle: {
              itemOne: "Availment Process",
              itemTwo: "Provider Directories",
              itemThree: "Frequently Asked Questions",
              itemFour: "Member Help Videos",
            },
          },
          ph: {
            title: "Maligayang Pagdating sa Information Center",
            description:
              "Makakuha ng mahahalagang impormasyon, gabay para sa mga miyembro, at mga madalas itanong tungkol sa mga serbisyo ng IMS Wellth Care.",
            faqTitle: "Mga Madalas Itanong",
            itemCategoriesTitle: {
              itemOne: "Proseso ng Paggamit ng Benepisyo",
              itemTwo: "Listahan ng mga Accredited Provider",
              itemThree: "Mga Madalas Itanong",
              itemFour: "Mga Video na Gabay para sa mga Miyembro",
            },
          },
        }[selectedLanguage.value])
    );
    const itemCategories = computed(() => [
      {
        id: 1,
        title: translations.value.itemCategoriesTitle.itemOne,
        subtitle: "",
        icon: "HeartSvg",
        isUrl: false,
        path: "/auth/support-center/information/availment-process",
      },
      {
        id: 2,
        title: translations.value.itemCategoriesTitle.itemTwo,
        subtitle: "",
        icon: "BuildingSvg",
        isUrl: true,
        path: "https://iwc.com.ph/services/providers",
      },
      {
        id: 3,
        title: translations.value.itemCategoriesTitle.itemThree,
        subtitle: "(FAQs)",
        icon: "FAQSvg",
        isUrl: false,
        path: "/auth/support-center/information/faq",
      },
      {
        id: 4,
        title: translations.value.itemCategoriesTitle.itemFour,
        subtitle: "",
        icon: "VideoSvg",
        isUrl: false,
        path: "/auth/support-center/information/videos",
      },
    ]);
    return {
      itemCategories,
      selectedLanguage,
      translations,
    };
  },
};
</script>
